<script>
  import { getContext } from "svelte";
  import SidePanelToggle from "lib/components/SidePanelToggle.svelte";
  import Toggle from "lib/components/Toggle.svelte";
  import SeamlessGridHeader from "lib/components/common/SeamlessGridHeader.svelte";

  export let showTypeSetting = false;
  export let showApplicationSetting = false;
  export let showElementType = true;
  export let showApplicationName = true;

  const role = getContext("role");
  $: isAdmin = $role?.role === "admin";
  $: hasSettings = isAdmin && (showTypeSetting || showApplicationSetting);
  $: panelTitle = hasSettings ? "Shortcuts & Settings" : "Shortcuts";
</script>

<SidePanelToggle
  label={panelTitle}
  title=""
  width="24rem"
  allowUnderlyingInteraction={true}
>
  <div class="panel-header">
    <SeamlessGridHeader
      header={panelTitle}
      indicatorColor="#e9f08e"
      tooltipText="Keyboard shortcuts for navigating and selecting entries."
    />
  </div>

  <section class="panel-section">
    <h2>Shortcuts</h2>
    <div class="shortcut-list">
      <span><kbd>Space</kbd> Check Row</span>
      <span><kbd>Shift</kbd> + <kbd>Space</kbd> Standard title</span>
      <span><kbd>↑</kbd><kbd>↓</kbd> Navigate entries</span>
      <span><kbd>←</kbd><kbd>→</kbd> Previous / Next</span>
      <span><kbd>Shift</kbd> + <kbd>←</kbd><kbd>→</kbd> Multi-select</span>
      <span><kbd>Enter</kbd> Open Anon-Menu</span>
      <span><kbd>Esc</kbd> Close Anon-Menu</span>
    </div>
  </section>

  {#if hasSettings}
    <section class="panel-section settings-section">
      <h2>Settings</h2>
      {#if showApplicationSetting}
        <Toggle text="Show application info" bind:active={showApplicationName} />
      {/if}
      {#if showTypeSetting}
        <Toggle text="Show element type" bind:active={showElementType} />
      {/if}
    </section>
  {/if}
</SidePanelToggle>

<style>
  .panel-section { display: flex; flex-direction: column; gap: 0.75rem; }
  h2 { margin: 0; color: var(--pax-black); font-size: 0.875rem; font-weight: 700; }
  .shortcut-list { display: flex; flex-direction: column; align-items: flex-start; gap: 0.6rem; }
  .shortcut-list span { display: flex; align-items: center; gap: 0.3rem; }
  .settings-section { margin: 0 -1.5rem; padding: 1rem 1.5rem; border-top: 1px solid var(--border-color); border-bottom: 1px solid var(--border-color); }
  .panel-header { margin: 0 -1.5rem; }
  kbd { min-width: 1.55rem; padding: 0.2rem 0.4rem; border: 1px solid #d7dbe0; border-radius: 0.25rem; background: #f7f8fa; text-align: center; }
</style>
